/**
 * تطبيق الحسابات is its own app (owner, 2026-10-30: he opened إثبات التحويلات and got the whole system — «عايزه ابليكيشن
 * لوحده لموظفين الحسابات»): its own address (/accounts-app), its own sign-in (/accounts-app/login), its own installable
 * manifest (public/accounts.webmanifest, which is also the share target), and one screen: إثبات التحويلات. Built the way
 * تطبيق التشغيل is (features/operations/opsApp.ts).
 */
import type { Permission } from '@shared/permissions'
import { ACCOUNTS_MANIFEST, ACCOUNTS_TITLE } from './accountsHtml'

export { ACCOUNTS_MANIFEST, ACCOUNTS_TITLE }

export const ACCOUNTS_HOME = '/accounts-app'
export const ACCOUNTS_LOGIN = '/accounts-app/login'
/** What opens the app. */
export const ACCOUNTS_PERMISSION: Permission = 'payoutProofs:read'

export const isAccountsPath = (pathname: string) => pathname === ACCOUNTS_HOME || pathname.startsWith(`${ACCOUNTS_HOME}/`)

/**
 * Someone given only this app (payoutProofs, nothing else that opens a screen): signing in to the main system lands
 * him in the app instead of a sidebar with nothing in it.
 */
export function onlyAccountsApp(granted: ReadonlySet<string>) {
  if (granted.has('system:superuser') || !granted.has(ACCOUNTS_PERMISSION)) return false
  return [...granted].every((p) => p.startsWith('payoutProofs:'))
}

/** Points the page at the app's own manifest, so "Install" from /accounts-app installs «Aliens Finance» only. */
export function applyAccountsManifest(doc: Document = document) {
  let link = doc.querySelector<HTMLLinkElement>('link[rel="manifest"]')
  if (!link) { link = doc.createElement('link'); link.rel = 'manifest'; doc.head.appendChild(link) }
  link.href = ACCOUNTS_MANIFEST
  let title = doc.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]')
  if (!title) { title = doc.createElement('meta'); title.name = 'apple-mobile-web-app-title'; doc.head.appendChild(title) }
  title.content = ACCOUNTS_TITLE
  doc.title = ACCOUNTS_TITLE
}
